import React, { FC, useEffect, useState } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

const MeasurementOverlay = styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 15px;
    border-radius: 8px;
    font-family: monospace;
    font-size: 14px;
    z-index: 1000;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

const MeasurementTitle = styled.div`
    font-weight: bold;
    margin-bottom: 10px;
    color: #4caf50;
`;

const MeasurementRow = styled.div`
    margin: 5px 0;
    display: flex;
    justify-content: space-between;
    gap: 15px;
`;

const MeasurementLabel = styled.span`
    color: #ccc;
`;

const MeasurementValue = styled.span`
    color: #fff;
    font-weight: bold;
`;

interface ModelMeasurementComponentProps {
    measures: { x: number; y: number; z: number } | any;
    onTimeout?: () => void;
    timeout?: number; // Timeout in milliseconds, default 5000
}

const ModelMeasurementComponent: FC<ModelMeasurementComponentProps> = ({ measures, onTimeout, timeout = 5000 }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (timeout > 0 && onTimeout) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                onTimeout();
            }, timeout);

            return () => clearTimeout(timer);
        }
    }, [timeout, onTimeout]);

    if (!isVisible || !measures) {
        return null;
    }

    // Format numbers to 2 decimal places
    const formatValue = (value: number) => {
        return Number(value).toFixed(2);
    };

    return (
        <MeasurementOverlay>
            <MeasurementTitle>{T._('Model Measurements', 'Composer')}</MeasurementTitle>
            <MeasurementRow>
                <MeasurementLabel>{T._('Width (X):', 'Composer')}</MeasurementLabel>
                <MeasurementValue>{formatValue(measures.x)} cm</MeasurementValue>
            </MeasurementRow>
            <MeasurementRow>
                <MeasurementLabel>{T._('Height (Y):', 'Composer')}</MeasurementLabel>
                <MeasurementValue>{formatValue(measures.y)} cm</MeasurementValue>
            </MeasurementRow>
            <MeasurementRow>
                <MeasurementLabel>{T._('Depth (Z):', 'Composer')}</MeasurementLabel>
                <MeasurementValue>{formatValue(measures.z)} cm</MeasurementValue>
            </MeasurementRow>
        </MeasurementOverlay>
    );
};

export default ModelMeasurementComponent;
